import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW1400KomaMediumComboBoxModel } from "../kymw1400-koma-medium-combo-box/kymw1400-koma-medium-combo-box.model";

interface GetKomaMediumListResponse {
  MediumType: string;
  MediumName: string;
  StopOrderCode: string;
  ProgressWorkNum: string;
  ProgressWorkName: string;
  ReceiptEOrderCode: string;
  ReceiptECatalogId: string;
  MediumTypeClass: string;
  DutiesFormDiv: string;
}

/**
 * コマ割を行う媒体を取得する
 *
 * @export
 * @class GetKomaMediumListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetKomaMediumListService extends PlessJsonResponderSub<GetKomaMediumListResponse> {

  private model: KYMW1400KomaMediumComboBoxModel;
  private orderCode = '';
  private successFunc: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetKomaMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400KomaMediumComboBoxModel} model モデルクラス
   * @param {string} orderCode 受注コード
   * @memberof GetKomaMediumListService
   */
  execute(model: KYMW1400KomaMediumComboBoxModel, orderCode: string, successFunc?: () => void) {
    this.model = model;
    this.orderCode = orderCode;
    this.successFunc = successFunc;
    this.send('KYMW14getKomaMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetKomaMediumListService
   */
  success(data: GetKomaMediumListResponse) {
    this.model.updateMediumList(data);
    if (this.successFunc) {
      this.successFunc();
    }
  }
}
